import zhCN from './zh-CN.js'
import enUS from './en-US.js'
import deDE from './de-DE.js'
import frFR from './fr-FR.js'

export default {
  locale: process.env.VUE_APP_I18N_LOCALE,
  fallbackLocale: process.env.VUE_APP_I18N_LOCALE,
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS,
    'de-DE': deDE,
    'fr-FR': frFR
  }
}
